<template>
  <router-link tag="li" :to="bookingLink"  class="campaign-booking-list-item">
    <div class="flex flex-col w-2/3">
      <div class="campaign-booking-list-item__name">{{ booking.name }}</div>
      <div v-if="booking.opportunities" class="flex flex-row flex-wrap">
        <div v-for="opportunity in booking.opportunities" :key="opportunity.id" class="flex flex-row align-center">
          <div class="bullet-point"></div>{{ opportunity.name }}
        </div>
      </div>
    </div>
    <div class="w-1/3">
      <div class="flex flex-row align-center">
        <div class="w-2/5" v-if="booking.client">{{ booking.client.company }} / {{ booking.client.name }}</div>
        <div class="w-1/5 flex flex-row justify-center"><span><i class="fa fa-user"></i> {{ booking.required_stars }}</span></div>
        <div class="w-2/5 flex flex-row justify-end spacer-r-1">
          <booking-status-label style="overflow-x: hidden;" :booking="booking"/>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import BookingStatusLabel from '../booking/BookingStatusLabel'
export default {
  components: {BookingStatusLabel},
  props: {
    booking: {
      required: true,
      type: Object
    }
  },

  computed: {
    bookingLink () {
      if (this.booking.status === 'vetting') {
        return { name: 'vetting.show', params: { id: this.booking.id } }
      }
      if (this.booking.type === 'request') {
        return { name: 'requests.show', params: { id: this.booking.id } }
      }
      if (this.booking.type === 'booking') {
        return { name: 'bookings.show', params: { id: this.booking.id } }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.campaign-booking-list-item {
  border: 1px #e3e3e3 solid;
  font-size: 12px;
  border-bottom: none;
  display: flex;
  padding: 10px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  &:last-child {
    border-bottom: 1px #e3e3e3 solid;
  }
  &__name {
    color: black;
    font-size: 14px;
    margin-left: 10px;
  }
  .bullet-point {
    width: 4px;
    height: 4px;
    background: black;
    margin-right: 5px;
    margin-left: 10px;
  }
}
</style>
